import { endpoints } from '../../../constants/routesAndApisConstants';

export const sendEmail = (email: string) => {
  return fetch(endpoints.CONFIRMATION_RESEND, {
    method: 'POST',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    body: `email=${email}`,
  });
};
